import { Observable } from './zenObservable';
export * from './zenObservable';
export default Observable;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-link-dedup/~/zen-observable-ts/lib/index.js
// module id = 219
// module chunks = 0